import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import firebase from "firebase/app";


Vue.config.productionTip = false;

const firebaseConfig = {
  apiKey: "AIzaSyDobhjHimjRm-Yr32AUo4gN2cZ2ElNjjQs",
  authDomain: "myfriendshipp.firebaseapp.com",
  databaseURL: "https://myfriendshipp-default-rtdb.firebaseio.com",
  projectId: "myfriendshipp",
  storageBucket: "myfriendshipp.appspot.com",
  messagingSenderId: "352657492422",
  appId: "1:352657492422:web:244c1aa83e53a0f7954ac7",
  measurementId: "G-ND4D7Z8WV3"
};

firebase.initializeApp(firebaseConfig);

let app;


if (!app) {
  app = new Vue({
    router,
    render: h => h(App)
  }).$mount("#app");
}


// app = new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount("#app");
